class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.closeButton = this.querySelector(".search-modal__close-button");
    this.onBodyClickEvent = this.onBodyClick.bind(this);

    this._closing = false;
    this._transitionHandler = null;
    this._closeFallback = null;

    this.detailsContainer.addEventListener("keyup", (event) => {
      if (event.code && event.code.toUpperCase() === "ESCAPE") this.close();
    });

    this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this));

    if (this.closeButton) {
      this.closeButton.addEventListener("click", (e) => {
        e.stopPropagation();
        this.close();
      });
    }

    this.summaryToggle.setAttribute("role", "button");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open") && !this.detailsContainer.classList.contains("closing");
  }

  onSummaryClick(event) {
    event.preventDefault();

    if (this._closing) {
      this._cancelClose();
      return;
    }

    if (this.detailsContainer.hasAttribute("open")) {
      this.close();
    } else {
      this.open(event);
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains("modal-overlay")) {
      this.close(false);
    }
  }

  open(event) {
    if (this._closing) this._cancelClose();

    if (!this.detailsContainer.hasAttribute("open")) {
      this.detailsContainer.setAttribute("open", "");
    }

    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");
    if (event && event.target && event.target.getAttribute && event.target.getAttribute("aria-label") === "Search") {
      document.body.classList.add("search-open");
    }

    this.detailsContainer.classList.remove("closing");
    this._closing = false;

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);

    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden", "search-open");

    if (!this.detailsContainer.hasAttribute("open") || this._closing) return;

    const modal = this.detailsContainer.querySelector(".search-modal");
    if (!modal) {
      this.detailsContainer.removeAttribute("open");
      return;
    }

    this._closing = true;

    const cleanupAfterClose = () => {
      if (this._closeFallback) {
        clearTimeout(this._closeFallback);
        this._closeFallback = null;
      }
      if (this._transitionHandler) {
        modal.removeEventListener("transitionend", this._transitionHandler);
        this._transitionHandler = null;
      }
      this.detailsContainer.classList.remove("closing");
      this.detailsContainer.removeAttribute("open");
      this._closing = false;
    };

    this._transitionHandler = (e) => {
      if (e.target !== modal) return;
      cleanupAfterClose();
    };
    modal.addEventListener("transitionend", this._transitionHandler);

    requestAnimationFrame(() => {
      this.detailsContainer.classList.add("closing");
      this._closeFallback = setTimeout(cleanupAfterClose, 420);
    });
  }

  _cancelClose() {
    const modal = this.detailsContainer.querySelector(".search-modal");
    if (this._transitionHandler && modal) {
      modal.removeEventListener("transitionend", this._transitionHandler);
      this._transitionHandler = null;
    }
    if (this._closeFallback) {
      clearTimeout(this._closeFallback);
      this._closeFallback = null;
    }
    this.detailsContainer.classList.remove("closing");
    this._closing = false;

    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");
  }
}

customElements.define("details-modal", DetailsModal);
